'use client'

import { Product } from '@repo/shopify/types'
import { Button } from '@repo/ui/components/button'
import { FunctionComponent, useEffect, useState } from 'react'
import { useWishlist } from '../../../providers/WishlistProvider'
import { Dictionary } from '../../../services/dictionary.service'

interface Props {
  handle: Product['handle']
  dictionary: Dictionary
}

const ProductWishlistButton: FunctionComponent<Props> = ({ handle, dictionary }) => {
  const { wishlist, isInWishlist, handleWishlistToggle } = useWishlist()
  const [inWishlist, setInWishlist] = useState(false)

  useEffect(() => {
    setInWishlist(isInWishlist(handle))
  }, [handle, isInWishlist, wishlist])

  return (
    <Button type='button' variant='ghostAuto' onClick={() => handleWishlistToggle(handle)}>
      {inWishlist ? dictionary?.wishlist?.removefromwishlist || 'Remove from Wishlist' : dictionary?.wishlist?.addtowishlist || 'Add to Wishlist'}
    </Button>
  )
}

export default ProductWishlistButton
